import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { parseQueryString } from '../routing';
import _ from 'lodash';

export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            const queryParams = parseQueryString(props.location.search, window.localStorage);
            const hasInquiryAuthToken = !!(queryParams.id && queryParams.iat);
            if (typeof rest.track === 'function') _.assign(props, { track: _.get(rest, 'track') });
            if (localStorage.getItem('user') || hasInquiryAuthToken) {
                return <Component {...props}/>;
            } else {
                return (
                    <Redirect to={{ pathname: '/', state: { from: props.location } }} />
                );
            }
        }}
    />
);
